export const hasWindow = () => {
    return typeof window !== "undefined";
};

export const canUseDOM = () => {
    return hasWindow() && !!window.document?.createElement;
};

export const getJsonPayload = (
    element?: HTMLElement,
    attribute?: string
): any => {
    const dataAttribute = attribute || "trackingInfo";
    const payload = element?.dataset[dataAttribute] || "{}";
    try {
        return JSON.parse(payload) || {};
    } catch {
        console.warn("hubo: unable to parse tracking payload");
    }

    return {};
};
